/* eslint-disable @typescript-eslint/no-explicit-any */
const History: any = {
  navigate: null,
  push: (page: any, ...rest: any) => History.navigate(page, ...rest),
}

export default History
